import { selectIsFetching as selectIsFetchingBasis } from './state/basis/selector'
import { selectIsFetching as selectIsFetchingFunnelBuilder } from './state/funnel-builder/selector'
import { selectIsFetching as selectIsFetchingStateResponsible } from './state/state-responsible/selector'
import { selectIsFetching as selectIsFetchingTransition } from './state/transition/selector'

export default {
    action: {},
    selector: {
        selectIsFetching: (state) => {
            return (
                selectIsFetchingBasis(state) ||
                selectIsFetchingFunnelBuilder(state) ||
                selectIsFetchingTransition(state) ||
                selectIsFetchingStateResponsible(state)
            )
        },
    },
}



// WEBPACK FOOTER //
// ./src/modules/analytics/index.js